import updateTree from './updateTree'

export default function config(state = {}, action) {
  switch (action.type) {

    case 'SET_APP_ROOT_PATH': {
      return updateTree(state, 'config.appRootPath', () => action.path)
    }

    case 'SET_SIDEBAR_OPEN': return updateTree(state, 'config.sidebarOpen', () => action.open)

    case 'SET_SIDEBAR': return updateTree(state, 'config.sidebar', () => action.sidebar)

    case 'SET_MEDIA_SIZE' : return updateTree(state, 'config.mediaSize', () => action.size)

    case 'SET_BADGES': return updateTree(state, 'config.badges', () => action.badges)

    case 'IS_WEBVIEW': return updateTree(state, 'config.isWebview', () => true)

    case 'WEBVIEW_REGISTRATION_WALKTHROUGH_COMPLETE': return updateTree(state, 'config.needsWebviewDriverWalkthroughComplete', () => true)

    case 'SET_FLASH': {
      // Whenever the flash changes, close the sidebar so the user can see it.
      const next = updateTree(state, 'config.sidebarOpen', () => false)

      return updateTree(next, 'config.flash', () => action.flash)
    }

    case 'CLEAR_FLASH': {
      if (state.config.flash && state.config.flash.id === action.id) {
        return updateTree(state, 'config.flash', () => null)
      } else {
        return state
      }
    }

    case 'SHOW_MESSAGES': return updateTree(state, 'config.messagesSkipped', () => false)
    case 'SKIP_MESSAGES': return updateTree(state, 'config.messagesSkipped', () => true)

    case 'MODAL_OPEN': return updateTree(state, 'config.modalOpen', () => true)
    case 'MODAL_CLOSE': return updateTree(state, 'config.modalOpen', () => false)

    case 'WAS_SIGNING_UP': return updateTree(state, 'config.wasSigningUp', () => true)

    case 'TOGGLE_CAG_HINTS': return updateTree(state, 'config.cagHints', cagHints => !cagHints)

    default:
      return {
        config: {
          appRootPath: '/',
          sidebarOpen: false,
          isWebview: false,
          messagesSkipped: false,
          modalOpen: false,
          cagHints: true,
          badges: [],
        },
        ...state
      }
  }
}